import { render, staticRenderFns } from "./MembersManagement.vue?vue&type=template&id=53d60d48&scoped=true&"
import script from "./MembersManagement.vue?vue&type=script&lang=js&"
export * from "./MembersManagement.vue?vue&type=script&lang=js&"
import style0 from "./MembersManagement.vue?vue&type=style&index=0&id=53d60d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d60d48",
  null
  
)

export default component.exports